import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TextInput,
} from "react-native";
import React, { useState } from "react";
import { observer } from "mobx-react";
import { Calendar } from "../../../Resources/Constants";
import { Feather } from "@expo/vector-icons";
import Colors from "../../../Resources/Color";
import { useTranslation } from "react-i18next";
import EditMacroView from "./EditMacroView";
import { useDevice } from "../../_layout";

const MacroRowView = observer(
  ({ seg, macroColorMap, onMacroPress, onRenameMacro }) => {
    const { isMobile } = useDevice();
    const [isEditHovered, setIsEditHovered] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [showingEditMacro, setShowingEditMacro] = useState(false);
    const { t } = useTranslation();

    if (seg.label) {
      return (
        <TouchableOpacity
          key={seg.key}
          style={{
            width: seg.span * Calendar.DAY_WIDTH,
            justifyContent: "center",
            alignItems: "center",
            height: 34,
            borderRadius: 10,
            backgroundColor: macroColorMap?.[seg.label] || "transparent",
            position: "relative",
          }}
          onPress={() => onMacroPress(seg)}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          disabled={showingEditMacro}
        >
          <Text
            numberOfLines={1}
            style={{ fontSize: 12, fontWeight: "600", paddingHorizontal: 6 }}
          >
            {seg.label}
          </Text>
          {(isHovered || isMobile) && (
            <View
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                bottom: 0,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setShowingEditMacro(true);
                }}
                style={{
                  paddingVertical: 2,
                  backgroundColor: "rgba(255,255,255,0.45)",
                  borderRadius: 8,
                  marginRight: 4,
                  paddingVertical: 2,
                }}
                onMouseEnter={() => !isMobile && setIsEditHovered(true)}
                onMouseLeave={() => setIsEditHovered(false)}
              >
                <Feather
                  name="edit-3"
                  size={14}
                  color={Colors.bubbleColor}
                  style={{
                    opacity: isEditHovered ? 0.6 : 1,
                    paddingRight: 4,
                    paddingLeft: 4,
                    paddingVertical: 1,
                  }}
                />
              </TouchableOpacity>
            </View>
          )}

          {showingEditMacro && (
            <EditMacroView
              isVisible={showingEditMacro}
              onClose={() => setShowingEditMacro(false)}
              initialLabel={seg.label}
              onSave={(newName) => {
                if (typeof onRenameMacro === "function") {
                  onRenameMacro(seg, newName);
                }
                setShowingEditMacro(false);
              }}
            />
          )}
        </TouchableOpacity>
      );
    }
    return (
      <View key={seg.key} style={{ width: seg.span * Calendar.DAY_WIDTH }} />
    );
  }
);

const styles = StyleSheet.create({});

export default MacroRowView;
